import React, { useEffect, useState } from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ButtonNew from "../../../common/components/button-new/button-new";
import ShareIcon from "@mui/icons-material/Share";
import { FavoriteBorder, Favorite } from "@mui/icons-material";
import CustomRating from "../../../common/components/rating-component/rating-component";
import { ProviderDetails } from "../details-page.types";
import "./DetailsPageHeader.scss";
import { toggleFavoriteProvider } from "../../../api/details-page.api";
import SharePartnerPopup from "../../../common/components/share-partner-popup/SharePartnerPopup";
import store from "../../../store";

interface Props {
  providerDetails: ProviderDetails;
}

const DetailsPageHeader: React.FC<Props> = ({ providerDetails }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // 600px
  const [isFavorite, setIsFavorite] = useState<boolean>(
    providerDetails?.isFavorite || false
  );
  const [shareOpen, setShareOpen] = useState(false);

  const isLoggedIn = store.getState()?.session?.isLoggedIn || false;

  const providerId = providerDetails?.id;

  const handleFavorite = async () => {
    if (!isLoggedIn) return;

    try {
      const response = await toggleFavoriteProvider(providerId);
      if (response.data?.success) {
        setIsFavorite(response.data?.data?.isFavorite);
      }
    } catch (error) {
      console.error("Error toggling favorite:", error);
    }
  };

  useEffect(() => {
    setIsFavorite(providerDetails?.isFavorite || false);
  }, [providerDetails?.isFavorite]);

  // Mobile Layout
  if (isMobile) {
    return (
      <Box className="details-header details-header--mobile">
        {/* Line 1 */}
        <Box className="details-header__line details-header__line--top">
          <Typography className="details-header__business-name">
            {providerDetails?.businessName || "-"}
          </Typography>
          <Box className="details-header__actions">
            {/* {isFavorite ? (
              <Favorite
                className="details-header__favorite-icon"
                fontSize="large"
                onClick={isLoggedIn ? handleFavorite : undefined}
                sx={{
                  cursor: isLoggedIn ? "pointer" : "default",
                }}
              />
            ) : (
              <FavoriteBorder
                className="details-header__favorite-icon"
                fontSize="large"
                onClick={isLoggedIn ? handleFavorite : undefined}
                sx={{
                  color: "#104145",
                  cursor: isLoggedIn ? "pointer" : "default",
                }}
              />
            )} */}

            <ShareIcon
              fontSize="large"
              className="details-header__share-icon"
            />
          </Box>
        </Box>

        {/* Line 2 */}
        <Box className="details-header__line details-header__line--bottom">
          <Box className="details-header__location">
            <LocationOnIcon className="details-header__location-icon" />
            <Typography className="details-header__address">
              {providerDetails?.location || "-"}
            </Typography>
          </Box>
          <Box className="details-header__rating-wrapper">
            <CustomRating
              value={providerDetails?.avgRating}
              totalReviews={providerDetails?.totalReviews}
            />
          </Box>
        </Box>
      </Box>
    );
  }

  // Desktop Layout
  return (
    <Box className="details-header details-header--desktop">
      <Box className="details-header__name-location">
        <Box className="details-header__name-wrapper">
          <Typography className="details-header__business-name">
            {providerDetails.businessName || "-"}
          </Typography>
          <Box className="details-header__location">
            <LocationOnIcon className="details-header__location-icon" />
            <Typography className="details-header__address">
              {providerDetails?.location || "-"}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box className="details-header__actions">
        <CustomRating
          value={providerDetails?.avgRating}
          totalReviews={providerDetails?.totalReviews}
        />

        {/* {isFavorite ? (
          <Favorite
            className="details-header__favorite-icon"
            onClick={isLoggedIn ? handleFavorite : undefined}
            sx={{
              color: "#FF1205 !important",
              cursor: isLoggedIn ? "pointer" : "default",
            }}
          />
        ) : (
          <FavoriteBorder
            className="details-header__favorite-icon"
            onClick={isLoggedIn ? handleFavorite : undefined}
            sx={{
              color: "#104145",
              cursor: isLoggedIn ? "pointer" : "default",
            }}
          />
        )} */}

        {/* <FavoriteBorder
          className="details-header__favorite-icon"
          onClick={handleFavorite}
          style={{ cursor: isLoggedIn ? "pointer" : "default" }}
        /> */}

        <ButtonNew
          text="Share"
          icon={<ShareIcon />}
          iconPosition="left"
          bgColor="#e8e8e8"
          textColor="#104145"
          borderColor="#15585D"
          onClick={() => setShareOpen(true)}
        />
      </Box>
      <SharePartnerPopup
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        partnerTitle={"Share - " + providerDetails.businessName}
        isPlanner={false}
        providerId={providerId}
      />
    </Box>
  );
};

export default DetailsPageHeader;
